import { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSupplierShippingLatestStatisticsQuery } from 'api';
import { listShouldShowSeeMore } from 'utils/helpers';

export const useLatestStatistics = () => {
  const [isAllShown, setIsAllShown] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { data = {} } = useSupplierShippingLatestStatisticsQuery({ supplierId: id });
  const { prices = [] } = data;
  const isSeeAllVisible = listShouldShowSeeMore(prices, 5);
  const priceList = useMemo(() => {
    return isAllShown ? prices : prices.slice(0, 5);
  }, [isAllShown, prices]);

  const onShowAllStateChange = useCallback(() => {
    setIsAllShown((prevState) => !prevState);
  }, []);
  return {
    data,
    isSeeAllVisible,
    isAllShown,
    priceList,
    onShowAllStateChange,
  };
};
